import TableList from "@components/templates/tablelist";
import {
    HttpMaterialList,
    HttpImportMaterial,
    HttpDownloadMaterialTemplate,
    HttpExportMaterial
} from "@/service/billing";
import { mapGetters } from "vuex";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpMaterialList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: "请选择至少一条数据" }));
            }
            switch (type) {
                case "edit":
                    this.operate = {
                        show: true,
                        params: { id: params, type: "edit" },
                        title: this.$t('global.common.edit', { defaultValue: "编辑" }),
                        component: "compUpdate",
                        width: "middle",
                        showFooter: false
                    };
                    break;
                case "add":
                    this.operate = {
                        show: true,
                        params: { type: "add" },
                        title: this.$t('global.common.add', { defaultValue: "添加" }),
                        component: "compUpdate",
                        width: "middle",
                        showFooter: false
                    };
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.import_data', { defaultValue: "导入数据" }),
                        width: 460,
                        showFooter: false,
                        name: "excelFile",
                        component: "compUpload",
                        ajaxRequest: HttpImportMaterial,
                        download: () => {
                            this.handleWebfs(
                                HttpDownloadMaterialTemplate,
                                // process.env.VUE_APP_APIURL_FBB+'/api/v2/packageMaterial/packageMaterialsTemplate',
                                {},
                                'download'
                            );
                        }
                    };
                    break;
                case "export":
                    this.handleWebfs(
                        HttpExportMaterial,
                        this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t('global.common.edit', { defaultValue: "编辑" }),
                    show: true,
                    params: id,
                    operate: "edit"
                }
            ];
        }
    },
    computed: {
        ...mapGetters("dictionary", ["getBillcusWareList"]),
        ToolsData() {
            return [
                {
                    label: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary"
                },
                {
                    label: this.$t('global.common.import', { defaultValue: "导入" }),
                    operate: "import",
                    theme: "info"
                },
                {
                    label: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    tag: "vSelect",
                    key: "EQ_warehouseId",
                    options: this.getBillcusWareList,
                    show: true,
                    props: {
                        filterable: true
                    }
                },
                {
                    label: this.$t('fbb.accountmanage.material_code', { defaultValue: "包材Code" }),
                    tag: "vInput",
                    key: "EQ_materialCode",
                    show: true
                },
                {
                    label: this.$t('fbb.accountmanage.material_name', { defaultValue: "包材名称" }),
                    tag: "vInput",
                    key: "EQ_name",
                    show: true
                }
            ];
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: "操作" }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: "warehouseId",
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.getBillcusWareList,
                            row.warehouseId
                        )
                },
                {
                    title: this.$t('fbb.accountmanage.material_code', { defaultValue: "包材Code" }),
                    key: "materialCode"
                },
                {
                    title: this.$t('fbb.accountmanage.material_name', { defaultValue: "包材名称" }),
                    key: "name"
                },
                {
                    title: this.$t('global.common.size', { defaultValue: '尺寸' }) + "(cm*cm*cm)",
                    key: "length",
                    render(h, { row }) {
                        return `${row.length} * ${row.width} * ${row.height}`
                    }
                },
                {
                    title: this.$t('global.common.weight', { defaultValue: '重量' }) + "(g)",
                    key: "weight"
                },
                {
                    title: this.$t('fbb.accountmanage.cost', { defaultValue: "成本" }),
                    key: "cost",
                    render(h, { row }) {
                        return `${row.cost} ${row.currency || 'USD'}`
                    }
                },
                // {
                //     title: "币种",
                //     key: "currency"
                // },
                {
                    title: this.$t('fbb.accountmanage.description', {defaultValue: "描述" }),
                    key: "remark"
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: "创建日期" }),
                    key: "createdAt",
                    sortable: true
                }
            ];
        }
    }
};
